import get from 'lodash/get';
import React from 'react';

import AppContext from '../services/Context';
import styled from '../styled-components';
import Icon from './Icon';

export default () => (
  <AppContext.Consumer>
    {({ theme }) => (
      <IconWrapper theme={theme}>
        <Icon name="spinner" spin />
      </IconWrapper>
    )}
  </AppContext.Consumer>
);

const IconWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  font-size: 100px;
  color: ${({ theme }) => get(theme, 'status.inProgress') || '#28AADC'};
`;
